import { useParams, useNavigate, Link } from 'react-router-dom';
import { useEditCompany } from '../../../hooks/company/useEditCompany.js';
import SuccessModal from '../../../components/modales/SuccessModal.jsx';
import ErrorModal from '../../../components/modales/ErrorModal.jsx';
import ValidationErrors from '../../../components/alerts/ValidationErrors.jsx';
import ROUTES from '../../../routes/Routes.js';

export default function EditCompany() {
    const { id } = useParams();
    const navigate = useNavigate();
    const {
        form,
        error,
        success,
        validationErrors,
        handleChange,
        submit,
        clearMessages
    } = useEditCompany(id);

    return (
        <>
            <div className='container mt-6'>
                <h1 className='text-center'>Editar empresa</h1>
                <div className="row mt-5">
                    <div className="col-sm-12 col-md-12 col-lg-7 mt-4 m-auto">
                        <div className="card mb-3">
                            <div className="pt-4 px-4 pt-md-5 px-md-5">
                                {/* Muestra el error del validator del backend */}
                                <ValidationErrors errors={validationErrors} onClose={clearMessages} />
                                <form onSubmit={(e) => {e.preventDefault();submit();}}>
                                    <div className="form-floating mb-3">
                                        <input className="form-control" id="floatingName" placeholder="Nombre" name="name" type="text" maxLength="100" value={form.name} onChange={handleChange} required />
                                        <label htmlFor="floatingType">Nombre *</label>                                        
                                    </div>
                                    <div className="form-floating mb-3">                                        
                                        <input className="form-control" id="floatingShortname" placeholder="Nombre corto de la empresa" name="shortname" type="text" maxLength="30" value={form.shortname} onChange={handleChange} required />
                                        <label htmlFor="floatingShortname">Nombre corto de la empresa *</label>
                                    </div>      
                                    <div className="form-floating mb-3">                                        
                                        <textarea className="form-control" id="floatingDescription" placeholder="Comentarios" name="description" maxLength="255" value={form.description || ""} onChange={handleChange} style={{height:"100px"}} ></textarea>
                                        <label htmlFor="floatingDescription">Descripción</label>
                                    </div>
                                    <div className="mt-5 mb-4 text-end">
                                        <button type="submit" className="btn btn-primary">Actualizar</button>
                                        <Link to={ROUTES.LIST_COMPANY} className="btn btn-secondary ms-3">Cancelar</Link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <SuccessModal
                show={!!success}
                message={success}
                onClose={() => navigate(ROUTES.LIST_COMPANY)}
            />

            <ErrorModal
                show={!!error}
                message={error}
                onClose={clearMessages}
            />
        </>
    );
}